import { useRef } from "react";
import { useClickAway } from "react-use";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { doesActiveMessageIdMatches } from "../../helpers";
import { DropdownActions } from "./DropdownActions";
import { HoverActions } from "./HoverActions";

export interface MessageActionsProps {
  activeMessageId: string | null;
  canUserModifyMessage?: boolean;
  chatRoom: any;
  chatRoomUrl?: string;
  chatThreadsEnabled?: boolean;
  currentParticipant?: any;
  isLiveStream?: boolean;
  isMessageThread?: boolean;
  isParentMessage?: boolean;
  isPinned?: boolean;
  isPinnedMessageAtTop?: boolean;
  isRenderedOnHeader?: boolean;
  message: any;
  onBookmarkToggle?: (messageId: any) => void;
  setActiveMessageId: (messageId: string | null) => void;
  setEditMessageId: (id: any) => void;
  setUnreadMessageFlow?: (value: boolean) => void;
  toggleDeleteConfirmationModal: () => void;
}

export const MessageActions = ({
  isPinned = false,
  setEditMessageId,
  currentParticipant = {},
  toggleDeleteConfirmationModal,
  message,
  chatRoom,
  isMessageThread = false,
  canUserModifyMessage = false,
  chatThreadsEnabled = false,
  isParentMessage = false,
  isPinnedMessageAtTop = false,
  isRenderedOnHeader = false,
  onBookmarkToggle,
  setUnreadMessageFlow,
  isLiveStream = false,
  chatRoomUrl,
  activeMessageId,
  setActiveMessageId,
}: MessageActionsProps) => {
  const clickHandlerRef = useRef(null);

  const handleOutsideClick = () => {
    setActiveMessageId(null);
  };
  const messageActionsId = `message-actions-${message.id}`;
  useClickAway(clickHandlerRef, handleOutsideClick);

  const shouldActiveMessageIdMatches = doesActiveMessageIdMatches({
    activeMessageId,
    id: message.id,
    isMessageThread,
  });

  return (
    <div className="absolute right-0 top-0 mb-3">
      <div
        id={messageActionsId}
        className={classNames(
          "border-primary bg-primary -mt-4 mr-4 flex rounded-md border",
          {
            "!-mt-1": isPinnedMessageAtTop,
            invisible: !activeMessageId || !shouldActiveMessageIdMatches,
            "group-hover/action:visible":
              !activeMessageId || shouldActiveMessageIdMatches,
          },
        )}
      >
        <div ref={clickHandlerRef}>
          <div className="flex min-h-[34px] items-center justify-around space-x-1 px-1">
            <HoverActions
              message={message}
              isMessageThread={isMessageThread}
              chatThreadsEnabled={chatThreadsEnabled}
              chatRoom={chatRoom}
              isParentMessage={isParentMessage}
              isRenderedOnHeader={isRenderedOnHeader}
              currentParticipant={currentParticipant}
              onBookmarkToggle={onBookmarkToggle}
              setActiveMessageId={setActiveMessageId}
            />
            {currentParticipant && (
              <DropdownActions
                isPinned={isPinned}
                setEditMessageId={setEditMessageId}
                currentParticipant={currentParticipant}
                toggleDeleteConfirmationModal={toggleDeleteConfirmationModal}
                message={message}
                chatRoom={chatRoom}
                isMessageThread={isMessageThread}
                canUserModifyMessage={canUserModifyMessage}
                setUnreadMessageFlow={setUnreadMessageFlow}
                isLiveStream={isLiveStream}
                chatRoomUrl={chatRoomUrl}
                setActiveMessageId={setActiveMessageId}
                isRenderedOnHeader={isRenderedOnHeader}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
